export const LOAD_POKEMON = 'LOAD_POKEMON'
export const LOAD_POKEMON_DONE = 'LOAD_POKEMON_DONE'
export const LOAD_POKEMON_ERROR = 'LOAD_POKEMON_ERROR'

export const SELECT_POKEMON = 'SELECT_POKEMON'
export const DESELECT_POKEMON = 'DESELECT_POKEMON'
export const SELECT_POKEMON_DONE = 'SELECT_POKEMON_DONE'
export const SELECT_POKEMON_ERROR = 'SELECT_POKEMON_ERROR'

export const SELECTED_POKEMON_LOADED = 'SELECTED_POKEMON_LOADED'

export const ACTIVATE_INTERSECTOR = 'ACTIVATE_INTERSECTOR'

export const SEARCH_POKEMON = 'SEARCH_POKEMON'
export const SEARCH_POKEMON_DONE = 'SEARCH_POKEMON_DONE'
export const SEARCH_POKEMON_ERROR = 'SEARCH_POKEMON_ERROR'

export const SHUFFLE_POKEMON = 'SHUFFLE_POKEMON'
export const SHUFFLE_POKEMON_DONE = 'SHUFFLE_POKEMON_DONE'

// MODAL
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL' 

// ALERTS
export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'